// src/apiService.js
import axios from 'axios'; // Make sure this line is present

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}`; // Replace with your actual API base URL

const getAuthKey = () => {
    return `${process.env.REACT_APP_API_SECURITY_KEY}`;
  };


export const fetchMenusByClientId = async (clientId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/menus/getClientMenusList/${clientId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateClientMenus = async (requestData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/menus/updateClientMenusList`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.statusCode === 1006) {
      // Returning a specific error message if the user already exists
      return { error:  data.result  };
    }else if(data.statusCode===1001){
      return { success: 'Updated Successfully' };
    }else{
      return { error: 'Fail' };
    } // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};



export const fetchMenusByRoleId = async (roleId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/admin/menus/getRoleMenusList/${roleId}`,
      {
        headers: {
          'auth_key': `${getAuthKey()}`,
        }
      }
    );
    return response.data; // Return the list of countries
  } catch (error) {
    console.error('Error fetching Data:', error);
    alert('Error fetching Data:', error);
    throw error;
  }
};


export const updateRoleMenus = async (requestData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/admin/menus/updateRoleMenusList`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': `${getAuthKey()}`,
      },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      alert('Network response was not ok');
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    // Check for specific status codes in the response
    if (data.statusCode === 1006) {
      // Returning a specific error message if the user already exists
      return { error:  data.result  };
    }else if(data.statusCode===1001){
      return { success: 'Updated Successfully' };
    }else{
      return { error: 'Fail' };
    } // Return the API response
  } catch (error) {
    console.error('Error submitting form:', error);
    alert('Error submitting form:', error);
    throw error; // Re-throw the error for handling in the component
  }
};

